import { t } from "@galaxy-io/dls/theme/tokens/t";
import { styled } from "@linaria/react";

export const QueryWorkspace = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  min-width: 0;
`;
export const QueryBody = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
`;
export const QueryMain = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
`;
export const EditorPane = styled.div`
  height: 100%;
  min-height: 0;
  flex-shrink: 0;
  overflow: auto;
  border-bottom: 0.5px solid ${t.color.border.primary};
`;
export const Results = styled.section`
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
`;
export const ResultBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
`;
